<template>
  <div>
    <div ref="plotlyChart" style="width:100%;height:400px;"></div>
  </div>
</template>

<script>
import Plotly from 'plotly.js-dist';

export default {
  name: 'TechGraphic',
  data() {
    return {
      x: [],
      y: []
    };
  },
  watch: {
    x() {
      this.renderChart();
    },
    y() {
      this.renderChart();
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const data = [{
        x: this.x,
        y: this.y.map(this.convertToNumbers),
        type: 'scatter',
        mode: 'lines+markers',
        marker: { color: 'red' },
        line: { shape: 'linear' }
      }];
      const layout = {
        title: 'Tech Trend',
        xaxis: { title: 'Year', tickvals: this.x},
        yaxis: { title: '', tickvals: [1, 2, 3], ticktext: ['Emerging', 'Growth', 'Mainstream'], range: [0.5, 3.5] }
      };
      Plotly.newPlot(this.$refs.plotlyChart, data, layout);
    },
    passData(Val) {
      this.x = Object.keys(Val);
      this.y = Object.values(Val);
    },
    convertToNumbers(item) {
      switch (item) {
        case 'Emerging':
          return 1;
        case 'Growth':
          return 2;
        case 'Mainstream':
          return 3;
        default:
          return 0;
      }
    }
  }
}
</script>

<style scoped>
div {
  max-width: 100%;
}
</style>
